<template>
  <div>
    <!-- <van-checkbox v-model="r.value" shape="square">{{ r.label }}</van-checkbox> -->
    {{ data }}
  </div>
</template>
<style scoped></style>
<script>
export default {
  props: {
    data: Array,
  },
  mounted() {},
  data() {
    return {};
  },
  methods: {},
};
</script>
